import React from 'react';
import { Card, HeaderText, BodyText, TextLink, Container, Row, Col  } from 'shared-portal-component';

import '@/components/organism/style.scss'
interface RegistrationSuccessProps {
  formData?: { code?: string };
  onNext: (values: { code: string }) => void;
  loading?: boolean;
  error?: string;
}
const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({ formData, onNext, loading, error }) => (
  <Container fluid>
    <Card>
      <Row spacing='md'>
        <Col xs={12}>
            <HeaderText text="Success!" className="header-text-auth" />
            <BodyText
              text="You’re all set! We’re taking you to the main PortalSIX application login page."
              className='body-text-auth'
              as="p"
            />
            <BodyText as="p" className='body-text-auth'>
              <TextLink
                text="You can also click here to go to the login page."
                href="/login"
                variant="primary"
                className="underline link"
              />
            </BodyText>
        </Col>
      </Row>
    </Card>
  </Container>
);

export default RegistrationSuccess;
